import { LOCALES } from 'i18n/locales';

export const workspaceIntl = {
    [LOCALES.ENGLISH]: {

        'workspace.hsg47.header': 'Important',
        'workspace.hsg47.description': 'By signing into the platform you are accepting the <linkTerms>End User Terms</linkTerms> which must be adhered to at all times, whilst using the platform. ',
        'workspace.hsg47.button': 'Permitted use under the End User Terms',

        'workspace.platform-notices.header': 'Upcoming downtime',
        'workspace.platform-notices.button': 'View all platform notices',
        'workspace.platform-notices.no-notices': 'No upcoming downtime.',
        'workspace.platform-notices.error': 'Upcoming downtime could not be loaded. Please try again later.',

        'workspace.news.header': 'What\'s new',
        'workspace.news.description': 'Find out what\'s new in NUAR and share your feedback with us',
        'workspace.news.button': 'Read the news page',

        'workspace.map.search.header': 'Find assets on the map',
        'workspace.map.search.description': 'Use postcode, USRN, UPRN...',
        'workspace.map.search.button': 'Open map page with search result',
        'workspace.map.search.textinput': 'Search input text',
        'workspace.map.search.placeholder': 'Search for a location...',
        'workspace.map.search.locateMe': 'Use my current location',

        'workspace.enquiries.header': 'Enquiries',
        'workspace.enquiries.description': 'Access enquiries that you\'ve made',
        'workspace.enquiries.button': 'Open enquiries page',

        'workspace.workpack.header': 'Downloads',
        'workspace.workpack.description': 'Access PDFs that you\'ve made',
        'workspace.workpack.button': 'Open downloads page',

        'workspace.network.coverage.header': 'Coverage list',
        'workspace.network.coverage.description': 'Identify asset owners using NUAR and your organisation\'s coverage area',
        'workspace.network.coverage.button': 'Open coverage page',

        'workspace.bookmarks.header': 'Bookmarks',
        'workspace.bookmarks.description': 'Access searches that you\'ve bookmarked',
        'workspace.bookmarks.button': 'Open saved bookmarks page',

        'workspace.observations.header': 'Observations',
        'workspace.observations.description': 'Access observations you\'ve recorded on the map',
        'workspace.observations.button': 'Open observations page',

        'workspace.admin.header': 'User administration',
        'workspace.admin.description': 'Update your organisation details',
        'workspace.admin.button': 'Open user administration portal',

        'workspace.reports.header': 'Data Reports',
        'workspace.reports.description': 'Access data reports on the admin portal',
        'workspace.reports.button': 'Open user administration portal',

        'workspace.help.header': 'Help and guidance',
        'workspace.help.description': 'Access help and guidance topics',
        'workspace.help.button': 'Open help page',

        'workspace.coming.soon.header': 'Features coming soon'

    },
    [LOCALES.WELSH]: {

        'workspace.hsg47.header': 'Pwysig',
        'workspace.hsg47.description': '[By signing into the platform you are accepting the <linkTerms>End User Terms</linkTerms> which must be adhered to at all times, whilst using the platform.]',
        'workspace.hsg47.button': '[Permitted use under the End User Terms]',

        'workspace.platform-notices.header': '[Upcoming downtime]',
        'workspace.platform-notices.button': '[View all platform notices]',
        'workspace.platform-notices.no-notices': '[No upcoming downtime.]',
        'workspace.platform-notices.error': '[Upcoming downtime could not be loaded. Please try again later.]',

        'workspace.news.header': 'Beth sy’n newydd',
        'workspace.news.description': 'Dysgwch beth sy’n newydd yn NUAR a rhannwch eich adborth â ni',
        'workspace.news.button': 'Darllenwch y dudalen newyddion',

        'workspace.map.search.header': 'Dod o hyd i asedau ar y map',
        'workspace.map.search.description': 'Defnyddio cod post, USRN, UPRN...',
        'workspace.map.search.button': 'Agor y dudalen map gyda chanlyniad chwilio',
        'workspace.map.search.textinput': 'Chwilio testun mewnbwn',
        'workspace.map.search.placeholder': 'Chwilio am leoliad...',
        'workspace.map.search.locateMe': 'Defnyddio fy lleoliad presennol',

        'workspace.enquiries.header': 'Ymholiadau',
        'workspace.enquiries.description': 'Ymholiadau mynediad rydych wedi eu gwneud',
        'workspace.enquiries.button': 'Agor y dudalen ymholiadau',

        'workspace.workpack.header': '[Downloads]',
        'workspace.workpack.description': '[Access PDFs that you\'ve made]',
        'workspace.workpack.button': '[Open downloads page]',

        'workspace.network.coverage.header': 'Rhestr cwmpas',
        'workspace.network.coverage.description': '[Identify asset owners using NUAR and your organisation\'s coverage area]',
        'workspace.network.coverage.button': 'Agor tudalen cwmpas',

        'workspace.bookmarks.header': 'Nodau tudalen',
        'workspace.bookmarks.description': 'Cyrchu chwiliadau rydych wedi creu nodau tudalen ar eu cyfer',
        'workspace.bookmarks.button': 'Agor tudalen nodau tudalen wedi\'u harbed',

        'workspace.observations.header': 'Arsylwadau',
        'workspace.observations.description': 'Cyrchu arsylwadau rydych chi wedi\'u cofnodi ar y map',
        'workspace.observations.button': 'Creu tudalen arsylwadau',

        'workspace.admin.header': 'Gweinyddiaeth defnyddwyr',
        'workspace.admin.description': 'Diweddaru manylion eich sefydliad',
        'workspace.admin.button': 'Agor porth gweinyddu defnyddwyr',

        'workspace.reports.header': '[Data Reports]',
        'workspace.reports.description': '[Access data reports on the admin portal]',
        'workspace.reports.button': '[Open user administration portal]',

        'workspace.help.header': 'Cymorth ac arweiniad',
        'workspace.help.description': 'Cyrchu pynciau cymorth ac arweiniad',
        'workspace.help.button': 'Agor tudalen cymorth',

        'workspace.coming.soon.header': 'Nodweddion yn dod yn fuan'
    }
};
